export default __webpack_public_path__ + "static/media/DONKEY.cf5d1747.gif";